<script setup lang="ts">
  import { Modal, Text, IconSuccess } from "@ui-kit";

  const { selected_range_id, items } = defineProps<{
    selected_range_id: string;
    items: { id: string; title?: string; subtitle?: string }[];
  }>();
  const emit = defineEmits<{ (e: "click:item", id: string): void }>();
</script>

<template>
  <Modal data-testid="moneymap-filter-range-modal">
    <div class="moneymap__filter-range">
      <div
        v-for="item in items"
        :key="item.id"
        class="moneymap__filter-range__item"
        :data-testid="`moneymap-filter-range-option-${item.id}`"
        @click="emit('click:item', item.id)"
      >
        <div class="moneymap__filter-range__item-details">
          <Text font="body-medium-16">{{ item.title }}</Text>
          <Text v-if="item.subtitle" font="body-regular-14" color="secondary">{{ item.subtitle }}</Text>
        </div>
        <IconSuccess v-if="selected_range_id === item.id" />
      </div>
    </div>
  </Modal>
</template>

<style scoped>
  .moneymap__filter-range {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .moneymap__filter-range__item {
    display: flex;
    gap: 8px;
    padding: 12px 16px;
    align-items: center;
  }

  .moneymap__filter-range__item-details {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2px;
  }
</style>
